import React from 'react';
import { Box, Typography, Container, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';

const sections = [
  {
    title: '1. Introduction',
    paragraphs: [
      'Welcome to Filmhook Apps, a digital platform owned and operated by FILM-HOOK MEDIAAPPS PRIVATE LIMITED ("Filmhook Apps", "Filmhook", "Company", "we", "our", or "us").',
      'Filmhook Apps is a professional networking, collaboration, recruitment, communication, and marketplace platform designed primarily for the entertainment, media, creative, and business industries. The platform enables eligible users to build professional profiles, showcase portfolios, connect with industry professionals, communicate, discover career opportunities, participate in recruitment and auditions, promote businesses, and engage with various services offered through the Filmhook ecosystem.',
      'These Terms of Service ("Terms") constitute a legally binding agreement between you ("User", "you", or "your") and FILM-HOOK MEDIAAPPS PRIVATE LIMITED governing your access to and use of the Filmhook Apps website, mobile applications, software, products, services, features, and any related technologies.',
      'By accessing or using Filmhook Apps, you acknowledge that you have read, understood, and agree to comply with these Terms of Service and all policies incorporated by reference.'
    ]
  },
  {
    title: '2. Acceptance of Terms',
    paragraphs: [
      'By creating an account, accessing, browsing, downloading, or otherwise using Filmhook Apps, you expressly agree to be legally bound by these Terms of Service.',
      'These Terms apply to all users of the platform, including but not limited to:'
    ],
    bullets: [
      'Artists',
      'Actors and Actresses',
      'Directors',
      'Producers',
      'Writers',
      'Musicians',
      'Technicians',
      'Journalists',
      'Businesses',
      'Production Houses',
      'Casting Agencies',
      'Recruiters',
      'Employers',
      'Service Providers',
      'Marketplace Sellers',
      'Marketplace Buyers',
      'General Users',
      'Visitors'
    ],
    footerParagraph: 'If you do not agree to these Terms, you must not access or use Filmhook Apps.'
  }
];

const TermsOfService = () => {
  return (
    <Box sx={{ py: { xs: 4, sm: 8, md: 12 }, minHeight: '80vh' }}>
      <Container maxWidth="md">
        <Box
          sx={{
            background: 'var(--bg-card)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            border: '1px solid var(--border-color)',
            borderRadius: '24px',
            p: { xs: 2.5, sm: 4, md: 7 },
            boxShadow: '0 16px 48px rgba(0,0,0,0.2)',
          }}
        >
          <Typography variant="h3" fontWeight={800} gutterBottom sx={{ color: 'var(--text-heading)', textAlign: 'center', mb: 1, fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3rem' } }}>
            Terms of Service
          </Typography>
          <Typography variant="h6" sx={{ color: '#5dade2', textAlign: 'center', mb: 3, fontWeight: 500, letterSpacing: '0.5px', fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.25rem' } }}>
            FILM-HOOK MEDIAAPPS PRIVATE LIMITED
          </Typography>
          <Box sx={{ width: 80, height: 3, background: 'linear-gradient(90deg, #07a4f5, #5dade2)', mx: 'auto', mb: 6, borderRadius: '2px' }} />

          {sections.map((section, idx) => (
            <Box key={idx} sx={{ mb: 6 }}>
              <Typography variant="h5" fontWeight={700} gutterBottom sx={{ color: 'var(--text-heading)', mb: 2, fontSize: { xs: '1.2rem', sm: '1.35rem', md: '1.5rem' } }}>
                {section.title}
              </Typography>
              
              {section.paragraphs.map((p, pIdx) => (
                <Typography key={pIdx} variant="body1" sx={{ color: 'var(--text-secondary)', lineHeight: 1.8, mb: 2, textAlign: 'justify', fontSize: { xs: '0.88rem', md: '1rem' } }}>
                  {p}
                </Typography>
              ))}

              {section.bullets && (
                <List sx={{ pl: 2, mb: 2 }}>
                  {section.bullets.map((bullet, bIdx) => (
                    <ListItem key={bIdx} alignItems="flex-start" disableGutters sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: '32px', mt: '8px' }}>
                        <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#5dade2' }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography variant="body1" sx={{ color: 'var(--text-secondary)', lineHeight: 1.7, textAlign: 'justify', fontSize: { xs: '0.88rem', md: '1rem' } }}>
                            {bullet}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              )}

              {section.footerParagraph && (
                <Typography variant="body1" sx={{ color: 'var(--text-secondary)', lineHeight: 1.8, mt: 2, textAlign: 'justify', fontSize: { xs: '0.88rem', md: '1rem' } }}>
                  {section.footerParagraph}
                </Typography>
              )}

              {idx < sections.length - 1 && (
                <Divider sx={{ mt: 5, borderColor: 'var(--border-subtle)' }} />
              )}
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default TermsOfService;
